import React from 'react';
import classnames from 'classnames';
import styles from './bulkFilesModal.module.scss';
import { useForm } from 'react-hook-form';
import { BulkFilesFormFields } from 'v2/utils/drmFileUtils';
import FormModal from 'v2/common/FormModal/FormModal';
import { BulkFilesForm } from './BulkFilesForm';
import { useConfirmSavedFiles } from 'v2/hooks';
import { BulkFilesConfirmation } from 'v2/models';

interface BulkFilesModalProps {
  onClose: () => void;
  primaryObjectType: 'DataVendor' | 'DataProduct';
  dataVendorId?: number;
  dataProductId?: number;
}

export const BulkFilesModal = ({
  onClose,
  primaryObjectType,
  dataVendorId,
  dataProductId,
}: BulkFilesModalProps) => {
  const formContext = useForm<BulkFilesFormFields>({
    mode: 'onChange',
  });

  const { mutate: confirmSavedFiles, isLoading } = useConfirmSavedFiles({
    onClose,
  });

  const handleOnSubmit = (data: BulkFilesFormFields) => {
    const bulkFileConfirmation: BulkFilesConfirmation = {
      ...data,
      primary_object_type: primaryObjectType,
      data_vendor_pk: dataVendorId ?? null,
      data_product_pk: dataProductId ?? null,
      files: JSON.parse(data.files),
    };
    confirmSavedFiles([bulkFileConfirmation]);
  };

  return (
    <FormModal
      title="Add Files"
      onClose={onClose}
      onSubmit={handleOnSubmit}
      isLoading={isLoading}
      formContext={formContext}
      className={classnames(styles.viewModals)}
    >
      <BulkFilesForm />
    </FormModal>
  );
};
